import { render, staticRenderFns } from "./news_sub.vue?vue&type=template&id=a9191614&scoped=true&"
import script from "./news_sub.vue?vue&type=script&lang=js&"
export * from "./news_sub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9191614",
  null
  
)

export default component.exports